import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />,
);

async function registerPushServiceWorker() {
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(
    registrations
      .filter((registration) => {
        const scriptURL = registration.active?.scriptURL || registration.installing?.scriptURL || registration.waiting?.scriptURL || "";
        return scriptURL && !scriptURL.endsWith("/sw-push.js");
      })
      .map((registration) => registration.unregister())
  );

  const registration = await navigator.serviceWorker.register("/sw-push.js", { scope: "/" });
  if (registration.waiting) {
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
  }
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    registerPushServiceWorker().catch((error) => {
      console.error("Push service worker registration failed:", error);
    });
  });
}
